import { isAssignmentsColumnHeaderRightClickMenuVar } from 'cache/adv-filtering'
import { createAgGridFrameworkComponents } from 'components/AgGrid'

/**
 * A way to register components so we can use them in AG-Grid instance.
 */
export const frameworkComponents = createAgGridFrameworkComponents(
  isAssignmentsColumnHeaderRightClickMenuVar
)
